<template>
  <div class="about-container info-html-wrapper">
    <h1 class="title">
      title
    </h1>
    <html-loader :url="contentUrl" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import HtmlLoader from './HtmlLoader';

  export default {
    components: { HtmlLoader },
    data() {
      return {
        pageHandle: 'my-page',
      };
    },
    computed: {
      ...mapState({
        locale: state => state.locale,
      }),
      contentUrl() {
        return this.locale ? `/static-html/${this.pageHandle}/${this.locale}.html` : null;
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ContentPage/DefaultContentPage.vue